import { z } from "zod";

export const AssetSchema = z.object({
  path: z.string(),
  id: z.string(),
  tags: z.string().array(),
  height: z.number().nullish(),
  size: z.number(),
  type: z.string(),
  width: z.number().nullish(),
});

export type Asset = z.infer<typeof AssetSchema>;

export const MetaDataSchema = z.object({
  tags: z.string().array(),
  categories: z.record(AssetSchema.array()),
});
